import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useNavigate, useParams } from "react-router-dom"
import Button from '../formfields/Button'
import Modal from '../ui-elements/Modal'
import GuestUserLoginForm from '../auth/GuestUserLoginForm'
import { useVoice } from '../context/voice/VoiceContext'

type Props = {

}

function VoiceDialog({}: Props) {

    const { 
        setShowModal, 
        tableData,
        loggedIn 
    } = useContext(GlobalContext)

    const {
        isListening,
        isRecognizerRunning,
        speechRecognitionSupported,
        startListening,
        stopListening,
        isListeningEnabled,
        setIsListeningEnabled
    } = useVoice()



    const [showDialog, setShowDialog] = useState(false)
    const [decision, setDecision] = useState<string | null>(localStorage.getItem('savedVoiceOption'))


    useEffect(() => {
        const isVoiceModeEnabledAtOrgLevel = tableData && tableData.Organisation && tableData.Organisation.Options && tableData.Organisation.Options.voiceMode === true ? true : false
        const isLoggedIn = loggedIn && loggedIn !== 'externalUser' ? true : false
        const isSpeechRecognitionSupported = speechRecognitionSupported() ? true : false


        // only show dialog if:
        // * voice mode enabled at org level
        // * no decision by user yet
        // * speech recognition supported
        // * logged in as non external user

        console.log(`🗣️ should voice mode dialog show?`)
        console.log(`
            isVoiceModeEnabledAtOrgLevel: ${isVoiceModeEnabledAtOrgLevel} 
            decision: ${decision} 
            isSpeechRecognitionSupported: ${isSpeechRecognitionSupported} 
            isLoggedIn: ${isLoggedIn}`
        )

        if (isVoiceModeEnabledAtOrgLevel && !decision && isSpeechRecognitionSupported && isLoggedIn) {
            console.log(`✅ showing voice mode dialog`)
            setShowDialog(true)
        } else {
            console.log(`⛔️ hiding voice mode dialog`)
            setShowDialog(false)
        }


    }, [tableData, decision, loggedIn, speechRecognitionSupported])


  

    useEffect(() => {
        if (!speechRecognitionSupported) return

        if (decision === "yes" && !isRecognizerRunning) {
            setIsListeningEnabled(true)
        }

        if (decision === "no" && isRecognizerRunning) {
            setIsListeningEnabled(false)
        }
    }, [decision])



    const clickYes = () => {
        localStorage.setItem('savedVoiceOption', 'yes')
        setDecision('yes')
        setShowModal({
            message:
                "Voice mode enabled. You can switch this on or off at any time in the main menu."
        })
    }

    const clickNo = () => {
        localStorage.setItem('savedVoiceOption', 'no')
        setDecision('no')
        setShowModal({
            message:
                "Voice mode disabled. You can switch this on or off at any time in the main menu."
        })
    }


    if (!showDialog) {
        return null
    }

    return <Modal>
            <div className="flex flex-col gap-2 items-center justify-center text-center">
                <p className="text-2xl font-bold font-righteous">
                    ChecQR now supports voice mode!
                </p>
                <p className="text-lg">
                    Would you like to enable this now?
                </p>
                <div className="w-full flex flex-row gap-1">
                    <Button
                        id={"voice-mode-yes"}
                        onClick={clickYes}
                        text="Yes"
                        variant="primary"
                        size="big"
                        fullwidth
                    />
                    <Button
                        id={"voice-mode-no"}
                        onClick={clickNo}
                        text="No"
                        variant="primary"
                        size="big"
                        fullwidth
                    />
                </div>
            </div>
        </Modal>
    
}

export default VoiceDialog